import {useFeatureSettingsContext, type FeatureSetting} from "./FeatureSettingsContext"

export const useReadFeatureSetting = (launchDarklySettingKey: string): any => {
    const {[launchDarklySettingKey]: value} = useFeatureSettingsContext<readonly FeatureSetting[]>()
    return value
}
